export const TEXT = {
    LINK_HAS_EXPIRED: 'Oops! This link has expired',
    LINK_NOT_AVAILABLE_TEXT_1: 'The upload link you used is no longer available',
    LINK_NOT_AVAILABLE_TEXT_2: 'if you\'d like to upload, ask the collection owner for a new link.',
    GO_TO_LOGIN_BUTTON_TEXT: 'Go to login'
};